import React, { Component } from 'react';
import { View, TouchableOpacity } from 'react-native';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import ProductImage from '../../react-component/productImage';

import { urlCdn } from '../../services/Api';

import { Creators as produtoSelecionadoActions } from '../../store/ducks/produto-selecionado';

import Text from '../../react-component/textComponent';

import styles from './styles';

class ItemLista extends Component {
    selecionarProduto = (item) => {
        if (!item.idProduto) return;

        this.props.selectProduto(item);
    };

    render() {
        const { item, numColumns, produtoSelecionado } = this.props,
            { idProduto, dsProduto, nrEan, empty, tpDisponivel } = item,
            isValidProduct = !!idProduto,
            isSelected = produtoSelecionado.includes(item),
            isIndisponivel = tpDisponivel === 1 || tpDisponivel === 2;

        const vlPrecoVigente = Number(item.vlPrecoVigente).toLocaleString(
            'pt-BR',
            {
                style: 'currency',
                currency: 'BRL'
            }
        );

        let produtoStyle = [
            styles.listItem,
            { flex: 1 / numColumns },
            isSelected ? styles.selectedItem : {},
            isValidProduct ? styles.productBorder : styles.notProduct,
            isIndisponivel && !isSelected
                ? styles.prodIndisponivel
                : styles.prodDisponivel
        ];

        return (
            <TouchableOpacity
                style={produtoStyle}
                onPress={() => this.selecionarProduto(item)}
            >
                {!empty && (
                    <View style={styles.itemWrap}>
                        <ProductImage
                            data={item}
                            urlCdn={urlCdn}
                            style={
                                isIndisponivel
                                    ? styles.imageIndisp
                                    : styles.image
                            }
                        />
                        <View style={styles.itemMaxWidth}>
                            <View
                                style={[
                                    styles.lineContent,
                                    styles.marginBottom
                                ]}
                            >
                                <View style={styles.itemName}>
                                    <Text>{dsProduto}</Text>
                                </View>
                            </View>
                            <View
                                style={[
                                    styles.lineContent,
                                    styles.marginBottom
                                ]}
                            >
                                <Text style={styles.itemInfo}>{nrEan}</Text>
                            </View>
                            <View style={styles.lineContent}>
                                <Text style={styles.itemValue}>
                                    {vlPrecoVigente}
                                </Text>
                            </View>
                        </View>
                    </View>
                )}
            </TouchableOpacity>
        );
    }
}

const mapStateToProps = ({ produtoSelecionado }) => ({
    produtoSelecionado
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators({ ...produtoSelecionadoActions }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ItemLista);
